import { fromUtcWallClock } from "@dream/domain";
import type { DateTime } from "luxon";

/**
 * Date dos callbacks do FullCalendar com `timeZone` nomeado.
 *
 * Os campos UTC são o relógio de parede no fuso do calendário, não um instante
 * UTC. Usar `DateTime.fromJSDate(date, { zone })` atrasa um dia em Fortaleza e
 * rotula a coluna da segunda como domingo.
 */
export function fromFullCalendarMarker(date: Date, timezone: string): DateTime {
  return fromUtcWallClock(date, timezone);
}

/** Instante ISO a persistir a partir de um Date de callback do FullCalendar. */
export function fullCalendarMarkerToIso(date: Date, timezone: string): string {
  return fromUtcWallClock(date, timezone).toUTC().toISO() ?? date.toISOString();
}
